import {
    Box,
    Grid,
} from "@chakra-ui/react";

import ForgotPasswordForm from "./components/ForgotPasswordForm";
import LoginShowcase from "../Login/components/LoginShowcase";

const ForgotPassword = () => {
    return (
        <Box
            minH="100vh"
            bg="#F8FAFC"
            p={{
                base: 0,
                md: 8,
            }}
        >
            <Box
                maxW="1400px"
                mx="auto"
                minH={{
                    base: "auto",
                    lg: "calc(100vh - 64px)",
                }}
                bg={{
                    base: "transparent",
                    md: "white",
                }}
                borderRadius={{
                    base: "0",
                    md: "24px",
                }}
                overflow="hidden"
                border={{
                    base: "none",
                    md: "1px solid",
                }}
                borderColor={{
                    md: "gray.200",
                }}
            >
                <Grid
                    minH={{
                        base: "auto",
                        lg: "100%",
                    }}
                    templateColumns={{
                        base: "1fr",
                        lg: "1fr 1fr",
                    }}
                >
                    <ForgotPasswordForm />

                    <Box
                        order={{
                            base: 2,
                            lg: 0,
                        }}
                    >
                        <LoginShowcase />
                    </Box>
                </Grid>
            </Box>
        </Box>
    );
};

export default ForgotPassword;